import React from "react";
import { useDispatch } from "react-redux";
import { bool, array } from "prop-types";

import { OPEN_HAMBURGER_MENU, OPEN_SEARCHBAR } from "../../../store/actions";
import { MenuItem } from "../../menu-item";

import "./navbar-menu.m.css";

const NavbarMenu = ({ menu, isHighlighter = false }) => {
  const dispatch = useDispatch();

  const toggleHandler = () => {
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });

    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: false,
    });
  };

  return (
    <ul styleName="navbar" className="navbar">
      {menu.length > 0 &&
        menu.map((item) => {
          return (
            <li key={item.title} styleName="menu-wrapper" className="menu-item-wrapper">
              <MenuItem item={item} menuStyle="menu-link" toggleHandler={toggleHandler} />
              {isHighlighter && <span styleName="highlighter"></span>}
            </li>
          );
        })}
    </ul>
  );
};

NavbarMenu.propTypes = {
  menu: array,
  isHighlighter: bool,
};

export default NavbarMenu;
